import { useState } from "react";
import ReactSelect, { components } from "react-select";

import Label from "../Label";
import { Control, Controller } from "react-hook-form";
import Hint from "./Hint";
import { useMutation } from "react-query";
import { fetchApi } from "../../../../helpers/reactQueryApi";
import { stringify } from "query-string";
import { debounce, map, split } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTag } from "@fortawesome/pro-regular-svg-icons";

export type Tag = {
  id: string;
  name: string;
};

function TagOption(props: any) {
  const isNew = split(props.data.value, "_")[0] === "new";

  return (
    <components.Option {...props}>
      <FontAwesomeIcon className="mr-2" icon={isNew ? faPlus : faTag} />
      {props.data.label}
    </components.Option>
  );
}

function TagMultiValue(props: any) {
  return (
    <components.MultiValue {...props}>
      <FontAwesomeIcon className="mr-2" icon={faTag} />
      {props.data.label}
    </components.MultiValue>
  );
}

type TagSelectArgs = {
  name: string;
  label?: string;
  multi?: boolean;
  required?: boolean | string;
  control?: Control<any>;
  placeholder?: string;
  isSearchable?: boolean;
  hint?: string;
};
export default function TagSelect({
  label,
  name,
  multi = false,
  required = false,
  control,
  placeholder,
  isSearchable = true,
  hint,
}: TagSelectArgs) {
  const [tags, setTags] = useState<Tag[] | []>([]);
  const { mutate: searchTags, isLoading } = useMutation<Tag[], Error, string>(
    (q: string) => fetchApi(`/tags/find?${stringify({ q })}`),
    { onSuccess: (tags) => setTags(tags) },
  );

  const debouncedSearchTags = debounce((q: string) => {
    searchTags(q);
  }, 200);

  return (
    <div className="control-group">
      {label && <Label label={label} required={!!required} />}
      <div className="controls remove-input-txt-border">
        <Controller
          name={name}
          control={control}
          rules={{ required: required }}
          render={({ field }) => (
            <>
              <ReactSelect
                closeMenuOnSelect
                isMulti={multi}
                placeholder={placeholder}
                isSearchable={isSearchable}
                options={map(tags, ({ name, id }) => ({
                  label: name,
                  value: id,
                }))}
                onInputChange={(q) => debouncedSearchTags(q)}
                noOptionsMessage={() => I18n.t("js.plugins.select2.no_match")}
                {...field}
                className="form-select-container"
                classNamePrefix="form-select"
                components={{ Option: TagOption, MultiValue: TagMultiValue }}
                isLoading={isLoading}
                unstyled
              />
              {hint && <Hint text={hint} />}
            </>
          )}
        />
      </div>
    </div>
  );
}
